import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-delete-ticket-sub-type',
  templateUrl: './delete-ticket-sub-type.component.html',
  styleUrls: ['./delete-ticket-sub-type.component.css']
})
export class DeleteTicketSubTypeComponent implements OnInit {

  model= false;
  data:any = []
  i = 0
  deleteId: any = "";
  

  constructor( private toastr: ToastrService,private generic_service: GenericService) { }

  modelSubtitle = false
  sub_ticket:any = []
  
  ngOnInit(): void {
    
    this.getAllSubTickets() 
  }

 
  cancelModel(){
    document.getElementById("closeModalButton1")?.click()
  }

  getAllSubTickets(){
    this.generic_service.getAllSubTickets().subscribe(
      (response:any)=>{
        this.sub_ticket = response.response;
        console.log(response)
      }
    )
  } 

  delSubTicket(){
    this.generic_service.delTicketSubType(this.deleteId).subscribe(
      (res:any)=>{
        this.toastr.success("Successfully Deleted");
        this.getAllSubTickets();
        this.cancelModel();
      },err=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  del(id:any){
    this.deleteId = id
  }



  
}

